<a [routerLink]="['/about/faq']" fragment="{{faq.id}}" data-test="link-to-faq">{{faq.question}}</a>
